/**
 * Dashboard Translations Module (French)
 * Matches English structure exactly
 * @module dashboard
 * @language fr
 */

export const dashboard = {
  index: {
    heroTitle: "Observatoire des Futurs des Conseils de Développement JCI",
    heroSubtitle: "Mesurer le Leadership Jeune, la Santé Mentale et l'Opportunité Économique Mondialement",
    heroDescription: "Une plateforme basée sur les données analysant les conditions pour les jeunes leaders dans 114 pays. Utilisant des métriques vérifiées du réseau mondial de JCI et des partenariats de recherche.",
    globalImpactTitle: "Impact Mondial en un Coup d'Œil",
    verifiedData: "Données vérifiées du Rapport d'Impact JCI 2025",
    globalMembers: "Membres Mondiaux",
    activeWorldwide: "Actifs dans le monde",
    projects: "Projets",
    period20242025: "Période: 2024-2025",
    volunteerHours: "Heures de Bénévolat",
    hoursContributed: "Heures contribuées",
    countries: "Pays",
    worldwidePresence: "Présence mondiale",
    localOrganizations: "Organisations Locales",
    activeCommunities: "Communautés actives",
    digitalReachTitle: "Portée et Empreinte Numérique",
    totalFollowers: "Abonnés Totaux",
    jciccUsers: "Utilisateurs jci.cc",
    memberDemographicsTitle: "Instantané de la Démographie des Membres",
    averageAge: "Âge Moyen",
    yearsOld: "Ans",
    universityEducated: "Éducation Universitaire",
    bachelorsOrHigher: "Licence ou supérieur",
    fullTime: "Temps plein",
    entrepreneurs: "Entrepreneurs",
    employmentStatus: "Statut d'Emploi"
  },
  charts: {
    noDataAvailable: "Données non disponibles",
    dataLoadingSoon: "Les données se chargeront bientôt",
    noFunnelData: "Données d'entonnoir non disponibles",
    configureProcessData: "Configurer les données du processus",
    radarUnavailable: "Données radar non disponibles",
    configurePerformanceIndicators: "Configurer indicateurs de performance",
    performanceUnavailable: "Données de performance non disponibles",
    configureTrendData: "Configurer données de tendance",
    currentProgress: "Progrès Actuel",
    goal2040: "Objectif 2040",
    mainValue: "Valeur Principale",
    trend: "Tendance",
    goal: "Objectif"
  },
  header: {
    title: "Observatoire des Futurs de la Jeunesse des Conseils de Développement JCI",
    subtitle: "Observatoire Mondial des Conseils de Développement",
    tagline: "Développer des Leaders pour un Monde en Évolution"
  },
  dashboard: {
    heroTitle: "Observatoire des Futurs de la Jeunesse des Conseils de Développement JCI",
    heroSubtitle: "Mesurer le Leadership Jeune, la Santé Mentale et l'Opportunité Économique",
    heroDescription: "Comprendre l'opportunité mondiale des jeunes à travers l'Indice des Futurs de la Jeunesse (YFI)",
    learnAboutFII: "En savoir plus sur le YFI",
    globalReach: "Portée Mondiale",
    activeMembersWorldwide: "Membres Actifs dans le Monde",
    acrossCountries: "Dans 114 Pays",
    localOrganizations: "Organisations Locales",
    impactDelivered: "Impact Livré",
    beneficiariesReached: "Bénéficiaires Atteints (2024-2025)",
    projectsImplemented: "Projets Mis en Œuvre",
    volunteerHours: "Heures de Bénévolat Contribuées",
    digitalPresence: "Présence Numérique",
    socialFollowers: "Abonnés sur les Réseaux Sociaux",
    monthlyImpressions: "Impressions Mensuelles",
    magazineReaders: "Lecteurs de Magazine (70+ pays)",
    websiteEngagement: "Engagement du Site Web",
    activeUsers: "Utilisateurs Actifs sur jci.cc",
    pageViews: "Pages Vues",
    avgSessionDuration: "Durée Moyenne de Session",
    whatIsFII: "Qu'est-ce que l'Indice des Futurs de la Jeunesse (YFI)?",
    fiiDescription: "Le YFI mesure l'opportunité des jeunes dans 114 pays en utilisant trois dimensions pondérées",
    mentalHealth: "Santé Mentale",
    mentalHealthDesc: "Prévalence de santé mentale, taux de suicide, accès aux services",
    workforcePreparation: "Préparation au Travail",
    workforceDesc: "Chômage des jeunes, développement des compétences, réussite éducative",
    entrepreneurship: "Entrepreneuriat",
    entrepreneurshipDesc: "Environnement des affaires, soutien à l'entrepreneuriat, innovation",
    exploreFullIndex: "Explorer l'Indice Complet",
    memberExperience: "Instantané de l'Expérience des Membres",
    basedOnSurvey: "Basé sur l'Enquête des Membres (2025)",
    keyDemographics: "Démographie Clé",
    averageAge: "Âge Moyen",
    years: "ans",
    genderDistribution: "Répartition par Sexe",
    male: "Masculin",
    female: "Féminin",
    other: "Autre",
    employmentStatus: "Statut d'Emploi",
    fullTimeEmployed: "Employé à Temps Plein",
    entrepreneurSelfEmployed: "Entrepreneur/Indépendant",
    student: "Étudiant",
    education: "Éducation",
    universityDegrees: "Diplômes Universitaires",
    regionalAgeRange: "Fourchette d'Âge Régionale",
    youngest: "Plus Jeune",
    oldest: "Plus Âgé",
    membershipTenure: "Ancienneté d'Adhésion",
    newMembersJoining: "Nouveaux membres rejoignant",
    buildingFoundation: "Construire la base",
    growingLeadership: "Développer le leadership",
    experiencedMembers: "Membres expérimentés",
    sustainedCommitment: "Engagement soutenu",
    projectsAcrossRegions: "projets dans 4 régions",
    demographicsMotivations: "Démographie et motivations",
    mentalHealthIndex: "Indice de Santé Mentale",
    fiiWeight: "du YFI • Données mondiales de crise",
    fiiRankingsAnalysis: "Indice et analyse du YFI",
    digitalReach: "Tendances numériques et innovation",
    howFIICalculated: "Comment le YFI est calculé",
    conferencesPrograms: "Conférences et programmes JCI",
    strategicGrowthTargets: "Objectifs de croissance stratégique",
    regionalCouncils: "AMDEC, ADC, APDC, EDC",
    howToContribute: "Comment contribuer",
    frequentlyAskedQuestions: "Questions fréquemment posées"
  },
  metrics: {
    membersActive: "Membres Actifs",
    countriesPresent: "Pays Présents",
    startupsSupported: "Startups Soutenues",
    sustainableProjects: "Projets Durables",
    completed: "complété",
    countries: "Pays",
    members: "Membres",
    projects: "Projets",
    projectsPerYear: "Projets/an",
    memberDensity: "Densité des Membres",
    country: "Pays",
    regionalDistribution: "Distribution Régionale",
    globalPresence: "Présence mondiale de JCI en 2025",
    activeMembers: "Membres Actifs",
    globally: "dans le monde",
    worldwidePresence: "présence mondiale",
    communities: "Communautés",
    activeCommunities: "communautés actives",
    yearsOfHistory: "Années d'Histoire",
    since1915: "depuis 1915",
    vs2024: "vs 2024",
    annualProjects: "Projets Annuels",
    in2025: "en 2025"
  },
  dashboardTenure: {
    lessThan1Year: "<1 an",
    years1to3: "1-3 ans",
    years4to6: "4-6 ans",
    years7to9: "7-9 ans",
    moreThan10Years: ">10 ans",
    respondents: "répondants"
  },
  homeGlobalPresence: {
    title: "Présence Mondiale JCI",
    subtitle: "Actif dans 114 Pays à travers 4 Régions",
    regions: "Régions",
    countries: "Pays",
    members: "Membres",
    localOrgs: "Orgs Locales"
  },
  globalPresenceMap: {
    title: "Présence Mondiale JCI",
    subtitle: "Actif dans 114 Pays à travers 4 Régions",
    countriesLabel: "pays",
    regionsLabel: "régions",
    countriesCount: "Pays",
    membersCount: "Membres",
    localOrgs: "Organisations Locales",
    regions: {
      asiaPacific: "Asie et le Pacifique",
      europe: "Europe",
      africaMe: "Afrique et Moyen-Orient",
      americas: "Amérique"
    }
  },
  observatoryHeader: {
    title: "Observatoire des Futurs JCI",
    subtitle: "Observatoire Mondial des Conseils de Développement",
    tagline: "Développer des Leaders pour un Monde en Évolution",
    members: "Membres",
    countries: "Pays",
    beneficiaries: "Bénéficiaires",
    projects: "Projets"
  },
  homeGlobalMap: {
    title: "Présence Mondiale JCI",
    subtitle: "Jeunes leaders actifs dans 114 pays",
    members: "Membres",
    countries: "Pays",
    localOrgs: "Orgs Locales",
    click: "Cliquez pour détails"
  },
  jciGlobalPresence: {
    title: "Présence Mondiale JCI",
    subtitle: "Actif dans 114 Pays à travers 4 Régions",
    countries: "pays",
    orgs: "orgs",
    regions: "régions",
    africaMiddleEast: "Afrique et Moyen-Orient",
    americas: "Amérique",
    asiaPacific: "Asie et le Pacifique",
    europe: "Europe"
  },
  chartsAdvanced: {
    loading: "Chargement du graphique...",
    noData: "Données non disponibles",
    error: "Échec du chargement du graphique",
    xAxis: "Axe X",
    yAxis: "Axe Y",
    legend: "Légende",
    tooltip: "Info-bulle",
    zoom: "Zoom",
    pan: "Déplacer",
    reset: "Réinitialiser",
    download: "Télécharger"
  },
  digitalEcosystem: {
    title: "Écosystème Numérique JCI",
    subtitle: "Plateformes numériques alimentant l'engagement et la portée des membres",
    website: "Site Web",
    socialMedia: "Réseaux Sociaux",
    magazine: "Magazine",
    activeUsers: "Utilisateurs Actifs",
    followers: "Abonnés",
    readers: "Lecteurs",
    engagement: "Engagement",
    reach: "Portée",
    impressions: "Impressions"
  },
  observatoryMastery: {
    title: "Maîtrise de l'Observatoire",
    modulesExplored: "Modules Explorés",
    outOf: "sur",
    observer: "Observateur",
    analyst: "Analyste",
    visionary: "Visionnaire",
    keepExploring: "Continuez à explorer pour débloquer des insights !",
    almostThere: "Presque là ! Vous devenez un expert.",
    masterAchieved: "Vous maîtrisez l'Observatoire !",
    unlockReward: "Visitez tous les modules pour débloquer le Résumé Exécutif",
    loginToTrack: "Connectez-vous pour suivre votre progression sur les 14 modules",
    signInToStart: "Se connecter"
  },
  apiAnalytics: {
    title: "Analytique API",
    description: "Surveillez l'utilisation, les performances et les tendances de l'API",
    last24Hours: "Dernières 24 Heures",
    last7Days: "7 Derniers Jours",
    last30Days: "30 Derniers Jours",
    totalRequests: "Total des Requêtes",
    successful: "réussies",
    avgResponseTime: "Temps de Réponse Moyen",
    acrossAllEndpoints: "Sur tous les endpoints",
    errorRate: "Taux d'Erreur",
    errors: "erreurs",
    activeApiKeys: "Clés API Actives",
    totalKeys: "clés totales",
    requestsOverTime: "Requêtes au Fil du Temps",
    requestsByDay: "Requêtes API par jour",
    requestsByEndpoint: "Requêtes par Endpoint",
    distributionAcrossEndpoints: "Répartition entre les endpoints API",
    responseStatusCodes: "Codes de Statut de Réponse",
    distributionOfStatusCodes: "Répartition des codes de statut HTTP",
    topApiKeys: "Principales Clés API",
    keysWithHighestUsage: "Clés avec le plus d'utilisation",
    active: "Active",
    inactive: "Inactive",
    noApiKeysFound: "Aucune clé API trouvée"
  }
} as const;
